import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import Swal from 'sweetalert2/dist/sweetalert2.js';

import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  Form
} from '@angular/forms';
import { SubcategoryService } from 'src/app/services/subcategory.service';

/*
<div *ngFor="let subcategory of category.controls.subcategorias.controls; let j=index" [formGroupName]="j" class="row">
  <div class="col">
    <ng-select class="ng-select-visible" formControlName="subcategoria" [items]="category.controls.list.value" placeholder="Selecione uma subcategoria" (change)="onChangeDetail()" (clear)="onChangeDetail()" bindLabel="ds_subcategoria" bindValue="idsubcategoria"></ng-select>
    <button (click)="removeSubcategoria(category.controls.subcategorias, j)" *ngIf="category.controls.subcategorias.controls.length > 1" type="button" class="btn btn-danger-outline">remover</button>
  </div>
</div>
*/

@Component({
  selector: 'app-subcategoria-item',
  templateUrl: './subcategoria-item.component.html',
  styleUrls: ['./subcategoria-item.component.scss']
})
export class SubcategoriaItemComponent implements OnInit {
  @Input() subcategorias: FormArray;
  @Input() list: [];
  @Input() id: number;

  @Output() onChangeEvent = new EventEmitter<FormArray>();

  public frmSubcategoria: FormGroup

  constructor(private _SubcategoryService: SubcategoryService) {
  }

  ngOnInit(): void {
    this.realoadSubcategoria(this.id)
  }

  public realoadSubcategoria(id: number) {
    if (this.id == id) {
      if (this.frmSubcategoria) this.frmSubcategoria.reset()

      for (let i in this.subcategorias.controls) {
        let fg = <FormGroup>this.subcategorias.controls[i]
        fg.controls['showText'] = new FormControl(false)
        if (fg.controls['subcategoria'] && fg.controls['subcategoria'].value) {
          this.getSubcategorias(fg, false)
        }
      }
      this.frmSubcategoria = new FormGroup({
        subcategorias: this.subcategorias
      })
    }
  }

  public newSubcategory(frm: FormGroup) {
    frm.controls.subcategoria.setValue(null)
    let status = frm.controls.showText.value
    frm.controls.showText.setValue(!status)
  }

  public addNewSubcategory(frm: FormGroup) {
    if (!frm.controls.subcategorias) {
      frm.controls['subcategorias'] = new FormArray([])
    }

    if (!frm.controls.list) {
      frm.controls['list'] = new FormControl([])
    }

    let arr = <FormArray>frm.controls.subcategorias

    arr.push(new FormGroup({
      subcategoria: new FormControl(null),
      subcategorias: new FormArray([]),
      showText: new FormControl(false),
      list: new FormControl([])
    }))
  }

  public resetSubcategoria(subcategorias:FormGroup) {
    subcategorias.controls.subcategorias = new FormArray([])
  }

  getSubcategorias(subcategorias: FormGroup, add: boolean = true): void {
    if (subcategorias.controls.subcategoria.value == null) return

    if (!subcategorias.controls.loadingSubcategoria) {
      subcategorias.controls['loadingSubcategoria'] = new FormControl(true)
    }
    this._SubcategoryService.getSubcategoriesFrom(subcategorias.controls.subcategoria.value).subscribe((res) => {
      if (res.subcategorias) {
        if (!subcategorias.controls.list) {
          subcategorias.controls['list'] = new FormControl([])
        }

        subcategorias.controls.loadingSubcategoria.setValue(false)
        subcategorias.controls.list.setValue(res.subcategorias)

        if (res.subcategorias.length > 0 && add) {
          this.addNewSubcategory(subcategorias)
        }
      }
    })
  }

  onChangeSubcategoria(subcategorias: FormGroup): void {

    this.resetSubcategoria(subcategorias)
    this.getSubcategorias(subcategorias)

    this.onChangeDetail()
  }

  public removeSubcategoria(frm: FormArray, j) {
    Swal.fire({
      title: 'Você deseja remover a subcategoria do produto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        frm.controls.splice(j, 1)
        this.onChangeDetail()
      }
    })
  }

  public onChangeDetail() {
    this.eventChange()
  }

  public eventChange() {
    this.onChangeEvent.emit(this.subcategorias);
  }

}
